import React from 'react';

import { cn } from '@/lib/utils';
import { ScrollArea } from '@/components/ui/scroll-area';

export interface FullLayoutRightSidebarProps extends Omit<React.ComponentPropsWithoutRef<'aside'>, 'children'> {
  open: boolean;
  children: React.ReactNode;
  scrollable?: boolean;
}

const FullLayoutRightSidebar = React.forwardRef<HTMLElement, FullLayoutRightSidebarProps>(
  ({ open, scrollable = true, className, children, ...props }, ref) => {
    return (
      <aside
        ref={ref as React.Ref<HTMLDivElement>}
        data-slot="full-layout-right-sidebar"
        data-state={open ? 'open' : 'closed'}
        className={cn(
          'bg-background shadow-lg flex flex-col',
          'fixed h-[calc(100dvh-var(--header-nav-height))] z-10 w-screen transition-transform duration-300 ease-in-out data-[state=closed]:translate-x-full data-[state=open]:translate-x-0',
          'md:relative md:h-dvh md:w-96 md:top-0',
          'border-dark-300 border-l border-r-0 border-t-0 border-b-0',
          className,
        )}
        {...props}
      >
        <div className="flex flex-col flex-1 min-h-0 overflow-hidden" data-slot="full-layout-right-sidebar-content">
          {scrollable ? (
            <ScrollArea className="h-[calc(100dvh-var(--header-nav-height))] md:h-dvh">{children}</ScrollArea>
          ) : (
            children
          )}
        </div>
      </aside>
    );
  },
);

FullLayoutRightSidebar.displayName = 'FullLayoutRightSidebar';

export { FullLayoutRightSidebar };
